import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import validate from './ClubRecognitionCategoryMeasureApprovalsValidation';

import { navLinks } from '../../../UseNavLinks';

import useCategoryMeasureScoreData from '@usas/ui-web/state/categoryMeasureScore/UseCategoryMeasureScoreData';
import useRecFileData from '@usas/ui-web/state/recFile/UseRecFileData';
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';

import Constants from '@usas/ui-web/utils/Constants';
import useForm from '@usas/ui-web/utils/UseForm';
import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const useClubRecognitionCategoryMeasureApprovals = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryMeasureScoreState, putCategoryMeasureScore } = useCategoryMeasureScoreData();
  const { getRecFile } = useRecFileData();
  const { environmentVariableState, FILE_UPLOAD_MEASURE_TYPE_ID } = useEnvironmentVariableData();
  const { formState, errorState, updateFormState, setFormData, handleSubmit
  } = useForm(getInitialFormState, submitFormCallback, validate);
  const [state, setState] = useState({
    categoryMeasure: {}, programLevel: {}, qualifiedOrgUnitCode: '',
    clubName: '', submissionDate: '', tryRedirect: false, isFileUpload: false
  });

  const createCategoryMeasureScoreObj = () => {
    let obj = {};

    obj = {
      categoryMeasureScoreId: state.categoryMeasure?.categoryMeasureScoreId,
      programLevelInstanceId: state.programLevel?.programLevelInstanceId,
      categoryMeasureId: state.categoryMeasure?.categoryMeasureId,
      submittedValue: state.categoryMeasure?.submittedValue,
      submittedById: null,
      categoryMeasure: undefined,
      score: formState.score,
      notes: formState.notes.trim()
    }

    return obj;
  };

  const onBackClicked = () => {
    navigate(navLinks.CLUB_RECOGNITION_REQUEST, { state: { isRevisit: location.state?.isRevisit } });
  };

  const onCancelClicked = () => {
    navigate(navLinks.CLUB_RECOGNITION_PROGRAM_LEVEL, { state: { programLevel: state.programLevel, isRevisit: location.state?.isRevisit } });
  };

  const onDownloadUploadedFile = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    showUploadedFile(state.categoryMeasure?.submittedValue);
  };

  useEffect(() => {
    if (location.state && location.state.categoryMeasure &&
      location.state.programLevel && environmentVariableState.isLoaded === true) {
      const categoryMeasure = location.state.categoryMeasure;
      const programLevel = location.state.programLevel;
      setState({
        ...state,
        categoryMeasure: categoryMeasure,
        programLevel: programLevel,
        qualifiedOrgUnitCode: programLevel.qualifiedOrgUnitCode,
        clubName: programLevel.clubName,
        submissionDate: formatDate(programLevel.submissionDate),
        isFileUpload: categoryMeasure?.measureTypeId === FILE_UPLOAD_MEASURE_TYPE_ID ? true : false
      });
      setFormData({
        ...formState,
        score: categoryMeasure.score >= 0 ? categoryMeasure.score : '',
        notes: categoryMeasure.notes || '',
        minValue: categoryMeasure.minValue,
        maxValue: categoryMeasure.maxValue,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [environmentVariableState]);

  useEffect(() => {
    if (state.tryRedirect === true && categoryMeasureScoreState.isSaved === true) {
      navigate(navLinks.CLUB_RECOGNITION_PROGRAM_LEVEL, { state: { programLevel: state.programLevel, isRevisit: location.state?.isRevisit } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, categoryMeasureScoreState]);

  async function showUploadedFile(fileUrl) {
    if (fileUrl) {
      const getFileResult = await getRecFile(fileUrl);

      if (getFileResult) {
        if (getFileResult.objData?.blobFile?.size > 0) {
          var file = window.URL.createObjectURL(getFileResult.objData?.blobFile);
          const link = document.createElement('a');

          link.href = file;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      }
    }
  }

  function submitFormCallback() {
    putCategoryMeasureScore(state.categoryMeasure.categoryMeasureScoreId, createCategoryMeasureScoreObj());
    setState({ ...state, tryRedirect: true });
  }

  function getInitialFormState() {
    return {
      score: '',
      notes: '',
      minValue: 0,
      maxValue: 0
    };
  }

  return {
    location,
    Constants,
    state,
    categoryMeasureScoreState,
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged: updateFormState,
    onBackClicked,
    onCancelClicked,
    onDownloadUploadedFile
  };
};

export default useClubRecognitionCategoryMeasureApprovals;